import { ControlOutlined, DownloadOutlined, LoadingOutlined, PlusOutlined, PrinterOutlined, SearchOutlined, TableOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Input, Modal, Popover, Radio, Row, Space, Spin, Table, Tabs } from 'antd';
import Column from 'antd/es/table/Column';
import React, { useEffect, useState } from "react";
import { Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import { defaultAvatarImg, idQuyDauTu, searchLength } from '../../constants';
import { hideLoadingScreen } from '../../store/reducers/loading';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon } from '../../helpers/common';
import { NhanVienResponse, TimKiemNhanVienPagingResponse, TimKiemNhanVienRequest } from '../../models/nhanvien/NhanVien';
import { QuaTrinhCongTac } from '../../models/nhanvien/QuaTrinhCongTac';
import ContainerDonViPhuTrach from '../../modules/department/ContainerDonViPhuTrach';
import { timKiemDSNhanVien } from '../../services/nhanvien';
import { xuatBaoCaoNhanVien } from '../../services/report';
import TimKiemNangCaoSelectBox from '../utils/TimKiemNangCaoSeLectBox';
import InDanhSachNhanVien from './InDanhSachNhanVien';

const ALL_COLUMNS = [
    { key: 'ma', label: 'Mã nhân viên', required: false },
    { key: 'hoTen', label: 'Tên nhân viên', required: true  },
    { key: 'tenChucVu', label: 'Chức vụ', required: true  },
    { key: 'tenDonVi', label: 'Phòng ban', required: false  },
    { key: 'email', label: 'Email', required: false  },
    { key: 'dienThoai', label: 'Số điện thoại', required: false  },
    { key: 'gioiTinh', label: 'Giới tính', required: false },
    { key: 'ngaySinh', label: 'Ngày sinh', required: false },
    { key: 'ngayKetNap', label: 'Ngày kết nạp Đảng', required: false },
    { key: 'ngayChinhThuc', label: 'Ngày chính thức', required: false },
    { key: 'ngayVaoLam',     label: 'Ngày vào làm', required: false },
    { key: 'tenTrinhDoLLCT', label: 'Trình độ LLCT', required: false },
    { key: 'tenHocHam', label: 'Trình độ học vấn', required: false },
    { key: 'queQuan', label: 'Quê quán', required: false },
    { key: 'noiSinh', label: 'Nơi sinh', required: false },
    { key: 'diaChiNoiO', label: 'Địa chỉ nơi ở', required: false },
];

const STORAGE_KEY = 'dsnhanvien_columns';

const DanhSachNhanVien = () => {
    const dispatch = useDispatch();
    const [nhanVienShow, setNhanVienShow] = useState<NhanVienResponse | null>(null);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [idDonVi, setIdDonVi] = useState<number>(idQuyDauTu);
    const [showModalTimKiem, setShowModalTimKiem] = useState<boolean>(false);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [trangThaiFilter, setTrangThaiFilter] = useState<number | null>(1); // 1 = đang làm việc, null = tất cả
    const [rqTimKiem, setRqTimKiem] = useState<TimKiemNhanVienRequest>(new TimKiemNhanVienRequest);
    const [search, setSearch] = useState<any>();
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev={undefined} />;
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const menu: any = menuHelper.checkMultiPermission([Links.NhanVien.ChiTiet, Links.NhanVien.Xem]);
    const [danhsach, setDanhSach] = useState<TimKiemNhanVienPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });
    const getInitialColumns = (): string[] => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return JSON.parse(saved);
  } catch {}
  return ALL_COLUMNS.map(c => c.key);
};

const [selectedColumns, setSelectedColumns] = useState<string[]>(getInitialColumns);
const [showColumnPicker, setShowColumnPicker] = useState(false);
    const toggleColumn = (key: string, checked: boolean) => {
  setSelectedColumns(prev => {
    const next = checked ? [...prev, key] : prev.filter(k => k !== key);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
  });
};
const columnPickerContent = (
  <div style={{ minWidth: 200, maxHeight: 400, overflowY: 'auto' }}>
    {ALL_COLUMNS.map(col => (
      <div key={col.key} style={{ marginBottom: 8 }}>
        <Checkbox
          checked={selectedColumns.includes(col.key) || col.required}
          disabled={col.required}
          onChange={e => toggleColumn(col.key, e.target.checked)}
        >
          <span style={{ color: col.required ? '#999' : 'inherit' }}>
            {col.label}
          </span>
        </Checkbox>
      </div>
    ))}
  </div>
);
    const componentRef = React.createRef<any>();
    const printDanhSach = useReactToPrint({
        content: () => componentRef.current,
    });
    const onChangeDepartment = (e: any) => {
        if (e) {
            setIdDonVi(e.id);
            var rq = new TimKiemNhanVienRequest;
            rq.idDonVi = e.id;
            rq.tuKhoa = tuKhoa;
            rq.trangThai = trangThaiFilter;
            timkiem(rq, 0, 0, 0);
        } else {
            setIdDonVi(0);
            setDanhSach({
                "data": [],
                "recordsTotal": 0,
                "maxPage": 0,
                "pageCurrent": 0,
                "pageListShow": [0]
            });
        }
    };

    const timkiem = async (request: TimKiemNhanVienRequest, start: number, length: number, page: number) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            const temp = await timKiemDSNhanVien(request, start, length);
            const maxPage = temp?.recordsTotal === 0 ? 0 : (parseInt((temp?.recordsTotal / searchLength).toString()) + (temp?.recordsTotal % searchLength ? 0 : -1)) || 0;
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": maxPage,
                "pageCurrent": page,
                "pageListShow": []
            });

            setIsLoadingTable(false);
        }
        catch (err: any) {
            toast.error(err || "Tìm kiếm không thành công");
            setIsLoadingTable(false);
        };
    }

    const xuatBaoCao = async (request: TimKiemNhanVienRequest) => {
        try {
            setIsLoadingTable(true);
            var response = await xuatBaoCaoNhanVien({ ...request, selectedColumns });
            let link = document.createElement('a');

            link.download = `NhanSu_QuyDauTu.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            setIsLoadingTable(false);
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
            setIsLoadingTable(false);
        }
    }

    const containerDepartmentProps = {
        isKPI: false,
        donViQuanLy: true,
        onChange: onChangeDepartment,
        value: idDonVi
    }
    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            var rq = new TimKiemNhanVienRequest;
            rq.idDonVi = idDonVi;
            rq.tuKhoa = tuKhoa;
            rq.trangThai = trangThaiFilter;
            timkiem(rq, 0, 0, 0);
        }
    };
    // Reset fullscreen loading spinner khi vào trang (phòng trường hợp bị stuck từ page trước)
    useEffect(() => {
        dispatch(hideLoadingScreen());
    }, []);

    useEffect(() => {
        if (reloadPage) {
            setDanhSach({
                "data": [],
                "recordsTotal": 0,
                "maxPage": 0,
                "pageCurrent": 0,
                "pageListShow": [0]
            });
            var rq = new TimKiemNhanVienRequest;
            rq.idDonVi = idDonVi;
            rq.tuKhoa = tuKhoa;
            rq.trangThai = trangThaiFilter;
            timkiem(rq, 0, 0, 0);
            setReloadPage(false);
        }
    }, [reloadPage]);

    useEffect(() => {
        if (nhanVienShow) {
            const element = document.getElementById("detail-nhan-vien");
            element?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [nhanVienShow]);

    const buildRequest = (newTrangThai?: number | null) => {
        var rq = { ...rqTimKiem };
        rq.idDonVi = idDonVi;
        rq.tuKhoa = tuKhoa;
        rq.trangThai = newTrangThai !== undefined ? newTrangThai : trangThaiFilter;
        return rq;
    };

    return (<section>
        <Modal
            title="Tìm kiếm nâng cao"
            open={showModalTimKiem}
            onCancel={() => setShowModalTimKiem(false)}
            footer={null}
            width={800}
            destroyOnClose
        >
            {loading ?
                <div className='text-center'><Spin indicator={antIcon} /></div> :
                <TimKiemNangCaoSelectBox
                    searchInput={search}
                    onSubmit={(e) => {
                        const newRq: TimKiemNhanVienRequest = {
                            ...e.target.value,
                            idDonVi: idDonVi,
                            trangThai: trangThaiFilter,
                            tuKhoa: tuKhoa,
                        };
                        setRqTimKiem(newRq);
                        setShowModalTimKiem(false);
                        setSearch({
                            values: e.target.value,
                            labels: e.target.label
                        });
                        timkiem(newRq, 0, 0, 0);
                    }} />
            }
        </Modal>
        <ContentHeader title="Quản lý nhân sự" />
        <Row className="form-group" gutter={[8, 8]} align="middle">
            <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4}>
                <ContainerDonViPhuTrach {...containerDepartmentProps} />
            </Col>
            <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4}>
                <Input prefix={<SearchOutlined rev="" />} placeholder="Tên, mã NV, email, SĐT" onChange={(e) => setTuKhoa(e.target.value)}
                    onKeyPress={handleKeyPress} />
            </Col>
            <Col xs={24} sm={24} md={8} lg={6} xl={5} xxl={5}>
                <Radio.Group
                    value={trangThaiFilter === 1 ? 'danglamviec' : 'tatca'}
                    onChange={(e) => {
                        const newTrangThai = e.target.value === 'danglamviec' ? 1 : null;
                        setTrangThaiFilter(newTrangThai);
                        timkiem(buildRequest(newTrangThai), 0, 0, 0);
                    }}
                    buttonStyle="solid"
                    size="middle"
                >
                    <Radio.Button
                        value="danglamviec"
                        style={{ borderRadius: '999px 50 50 999px', fontWeight: 500 }}
                    >
                        Đang làm việc
                    </Radio.Button>
                    <Radio.Button
                        value="tatca"
                        style={{ borderRadius: '50 999px 999px 50', fontWeight: 500 }}
                    >
                        Tất cả
                    </Radio.Button>
                </Radio.Group>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={11}>
                <Space className="float-right" wrap>
                    <Button type="primary"
                        icon={<SearchOutlined rev="" />}
                        onClick={() => timkiem(buildRequest(), 0, 0, 0)}>
                        Tìm 
                    </Button>
                    <Popover
                        content={columnPickerContent}
                        title="Chọn cột hiển thị / xuất Excel"
                        trigger="click"
                        open={showColumnPicker}
                        onOpenChange={setShowColumnPicker}
                        placement="bottomRight"
                        >
                        <Button icon={<TableOutlined rev="" />}>
                            Chọn cột
                        </Button>
                    </Popover>
                    <Button className="hrm-btn hrm-btn-success" title = "Xuất excel"
                        icon={<DownloadOutlined rev="" />}
                        onClick={() => xuatBaoCao(buildRequest())}>
                        Xuất
                    </Button>
                    <Button
                        hidden={window.innerWidth <= 576} title ="In danh sách"
                        className="hrm-btn-print"
                        icon={<PrinterOutlined rev="" />}
                        onClick={() => printDanhSach()}>
                        In
                    </Button>
                    <Button type="primary" icon={<ControlOutlined rev="" />} onClick={() => { setShowModalTimKiem(true); setTuKhoa(""); }}>
                        Tìm nâng cao
                    </Button>
                    {menu[Links.NhanVien.ChiTiet] &&
                        <Link className="hrm-btn hrm-btn-warning" title="Thêm mới" to={Links.NhanVien.ChiTiet} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                            <PlusOutlined rev="" />Thêm 
                        </Link>
                    }
                </Space>
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={24 }>
                <div className="card card-primary">
                            <Table
                                loading={isLoadingTable}
                                locale={{emptyText:"Không có dữ liệu"} }
                                dataSource={(danhsach?.data || []).map((value, index) => { const item = { key: value.id, ...value }; return item; })}
                                scroll={{ x: Math.max(800, selectedColumns.length * 150) }}
                                sticky
                                onRow={(record, rowIndex) => {
                                    return {
                                        onClick: event => {
                                            if (record?.id === nhanVienShow?.id) {
                                                setNhanVienShow(null);
                                            } else {
                                                setNhanVienShow(record);
                                            }
                                        },
                                    };
                                }} 
                                pagination={{
                                    current: page, 
                                    onChange: (page, pageSize) => {
                                        setPage(page);
                                    },
                                }}
                                rowClassName={(record, index) => {
                                    return (record?.id === nhanVienShow?.id) ? "selected-row row-key-" : "";
                                }}
                            >
                                <Column
                                width={60}
                                title="STT"
                                key="STT"
                                render={(value, record, index) => (
                                    <span key={"stt" + value.stt}>
                                    {(page - 1) * searchLength + index + 1}
                                    </span>
                                )}
                                />
                                {ALL_COLUMNS
                                    .filter(col => selectedColumns.includes(col.key))
                                    .map(col => {
                                        if (col.key === "tenDonVi") {
                                            return (
                                                <Column
                                                    key={col.key}
                                                    title={col.label}
                                                    dataIndex={col.key}
                                                    width={220}
                                                    render={(value) => (
                                                        <div style={{
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: 'vertical',
                                                            overflow: 'hidden',
                                                            whiteSpace: 'normal',
                                                        }}>
                                                            {value}
                                                        </div>
                                                    )}
                                                />
                                            );
                                        }
                                        if (col.key === "diaChiNoiO") {
                                        return (
                                            <Column
                                            key={col.key}
                                            title={col.label}
                                            width={250}
                                            render={(value, record: any) => (
                                                <div style={{
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'normal',
                                                }}>
                                                    {[
                                                        record?.soNhaNoiO,
                                                        record?.tenPhuongXaNoiO,
                                                        record?.tenTinhThanhNoiO
                                                    ].filter(x => x).join(", ")}
                                                </div>
                                            )}
                                            />
                                        );
                                        }

                                    if (col.key === "gioiTinh") {
                                        return (
                                            <Column
                                                key={col.key}
                                                title={col.label}
                                                render={(value, record: any) =>
                                                    record?.gioiTinh === 0 ? "Nam" : "Nữ"
                                                }
                                            />
                                        );
                                    }

                                    if (["ngaySinh", "ngayKetNap", "ngayChinhThuc", "ngayVaoLam"].includes(col.key)) {
                                        return (
                                            <Column
                                            key={col.key}
                                            title={col.label}
                                            render={(value, record: any) =>
                                                dateCommon.formatDate(record?.[col.key])
                                            }
                                            />
                                        );
                                    }

                                    return (
                                        <Column
                                            key={col.key}
                                            title={col.label}
                                            dataIndex={col.key}
                                        />
                                    );
                                })
                                }
                                {menu[Links.NhanVien.Xem] && (
                                    <Column
                                        title=""
                                        key="action"
                                        fixed="right"
                                        width={100}
                                        render={(value, record, index) => (
                                        <Link key={"link" + index} className="hrm-btn hrm-btn-sm btn-primary"
                                            to={`${Links.NhanVien.Xem}?id=${value?.id}`}>
                                            Xem
                                        </Link>
                                        )}
                                    />
                                )}
                            </Table>
                </div>
            </Col>
        </Row>
        <Row gutter={8} id="detail-nhan-vien" style={{ display: nhanVienShow !== null ? "block" : "none" }}>
            <Col span={24}>
                <div className="hrm-preview-footer">
                    <div>
                        <Tabs defaultActiveKey="1" items={[
                            {
                                key: '1',
                                label: 'Thông tin cá nhân',
                                children:
                                    <div className="card pt-3 pb-2">
                                        <div className="tab-content">
                                            <Row >
                                                <Col xs={24} sm={6} md={9}>
                                                    <div className="text-center mb-3">
                                                        <img className="profile-user-img img-fluid img-circle"
                                                            src={(nhanVienShow?.avatar == null || nhanVienShow?.avatar == "") ? defaultAvatarImg : nhanVienShow?.avatar.replace(/\\/g, "/")}
                                                            /*src={(nhanVienShow?.avatar == null || nhanVienShow?.avatar == "") ? defaultAvatarImg : nhanVienShow?.avatar.replace("View\\public", "").replace(/\\/g, "/")}*/
                                                            alt="User profile picture" />
                                                    </div>
                                                    <div className="text-center">
                                                        <label className="mb-1">
                                                            <Link className="mb-1" to={Links.NhanVien.ChiTiet + "/" + nhanVienShow?.id}>{nhanVienShow?.hoTen?.toUpperCase()}</Link>
                                                        </label>
                                                    </div>
                                                    <div className="text-center"><label className="mb-1">{nhanVienShow?.ma?.toUpperCase()}</label></div>
                                                </Col>
                                                <Col xs={9} sm={6} md={5} style={{ marginLeft:"8px" }}>
                                                    <div className="mb-1">
                                                        <div>Chức vụ</div>
                                                        <label>{nhanVienShow?.tenChucVu}</label>
                                                    </div>
                                                    <div className="mb-1">
                                                        <div>Phòng ban</div>
                                                        <label>{nhanVienShow?.tenDonVi}</label>
                                                    </div>
                                                    <div>
                                                        <div>Email</div>
                                                        <label className="d-inline-block text-truncate" style={{ maxWidth: '100%' }}>{nhanVienShow?.email}</label>
                                                    </div>
                                                </Col>
                                                <Col xs={8} sm={5} md={4} style={{ marginLeft: "8px" }}>
                                                    <div className="mb-1">
                                                        <div>Giới tính</div>
                                                        <div>{nhanVienShow?.gioiTinh === 0 ? <Badge className="badge badge-pill badge-success"> Nam</Badge> :
                                                            <Badge className="badge badge-pill badge-danger"> Nữ</Badge>}
                                                        </div>
                                                    </div>
                                                    <div className="mb-1">
                                                        <div>Ngày sinh</div>
                                                        <label>{dateCommon.formatDate(nhanVienShow?.ngaySinh)}</label>
                                                    </div>
                                                    <div>
                                                        <div>Điện thoại</div>
                                                        <label>{nhanVienShow?.dienThoai}</label>
                                                    </div>
                                                </Col>
                                                <Col xs={5} sm={6} md={5} style={{ marginLeft: "8px" }}>
                                                    <div className="mb-1">
                                                        <div>Quốc tịch</div>
                                                        <label>{nhanVienShow?.tenQuocTich}</label>
                                                    </div>
                                                    <div className="mb-1">
                                                        <div>Tôn giáo</div>
                                                        <label>{nhanVienShow?.tenTonGiao}</label>
                                                    </div>
                                                    <div className="mb-1">
                                                        <div>Trình độ</div>
                                                        <label>{nhanVienShow?.tenHocHam}</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                            },
                            {
                                key: '2',
                                label: 'Quá trình công tác trước đây',
                                children:
                                    <div className="card">
                                        <Table
                                            locale={{ emptyText: "Không có dữ liệu" }}
                                            scroll={{ x: 600 }}
                                            dataSource={(nhanVienShow?.quaTrinhCongTacs || []).map((item: any, index) => { item.key = index; return item; })}
                                            pagination={false}
                                        >
                                            <Column
                                                title="STT"
                                                key="STT"
                                                render={(value, record, index) =>
                                                (
                                                    <>
                                                        {index + 1}
                                                    </>
                                                )
                                                }
                                            />
                                            <Column
                                                title="Từ ngày"
                                                key="tungay"
                                                render={(value: QuaTrinhCongTac, record, index) =>
                                                (
                                                    <>
                                                        {dateCommon.formatDate(value?.ngayBatDau)}
                                                    </>
                                                )
                                                }
                                            />
                                            <Column
                                                title="Đến ngày"
                                                key="denngay"
                                                render={(value: QuaTrinhCongTac, record, index) =>
                                                (
                                                    <>
                                                        {dateCommon.formatDate(value?.ngayKetThuc)}
                                                    </>
                                                )
                                                }
                                            />
                                            <Column title="Đơn vị" dataIndex="tenDonVi" key="tenDonVi" />
                                            <Column title="Phòng ban" dataIndex="phongBan" key="phongBan" />
                                            <Column title="Chức vụ" dataIndex="chucVu" key="chucVu" />
                                        </Table>
                                    </div>
                            },
                        ]}>
                        </Tabs>
                    </div>
                </div>
            </Col>
        </Row>
        <section style={{ display: 'none' }}>
            <div ref={componentRef}>
                <InDanhSachNhanVien
                    dataSource={danhsach.data}
                    selectedColumns={selectedColumns}
                />
            </div>
        </section>
    </section>
    );
};

export default DanhSachNhanVien;
